module.exports = __webpack_public_path__ + "static/gssoc-60890352baef38ac2091ee2591ce82fb.png";